<template>
  <div ref="chart">
    <Chart :extendData="extendData" :height="height" :id="id" :option="option" :width="width"  :route="route"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "LineChart",
  components: {Chart},
  props: {
    route: {
      type: String,
      default: ""
    },
    data: {},
    extendData: null,
    name: null,
    colorList: {
      type: Array,
      default: () => {
        return []
      }
    },
    unit: null,
  },
  data() {
    return {
      id: "lineChart",
      width: '100%',
      height: '100%',
      option: {},
    };
  },
  watch: {
    data() {
      this.getOption();
    },
  },
  mounted() {
    this.getOption()
  },
  methods: {
    getOption: function () {
      let labelColor = 'rgba(73, 164, 243, .2)';
      let colorList;
      if (this.colorList.length > 0) {
        colorList = this.colorList
      } else {
        colorList = ["rgba(16, 142, 233, 1)", 'rgba(50, 207, 210, 1)', '#F95453', '#FEDB5B']
      }
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            label: {
              show: false,
              backgroundColor: 'rgba(0,0,0,0)',
              color: '#556677',
              borderColor: 'rgba(0,0,0,0)',
              shadowColor: 'rgba(0,0,0,0)',
              shadowOffsetY: 0
            },
            lineStyle: {
              width: 0
            }
          },
          backgroundColor: 'rgba(0,0,0,0.5)',
          textStyle: {
            color: '#A7D6F4'
          },
          padding: [10, 10],
          extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
        },
        legend: {
          top: '8%',
          data: ["环比", "同比"],
          textStyle: {
            color: '#A7D6F4'
          },
        },
        grid: {
          top: '20%',
          right: '10%',
          left: '10%',
          bottom: '20%'
        },
        xAxis: [{
          type: 'category',
          data: this.data.time,
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            rotate: 30,
            interval: 0,
            textStyle: {
              color: '#A7D6F4'
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 15
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: labelColor
            }
          },
          boundaryGap: false,
        }],
        yAxis: [{
          name: '增长率%',
          nameTextStyle: {
            color: '#A7D6F4'
          },
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: labelColor
            }
          },
          axisLabel: {
            textStyle: {
              color: '#A7D6F4'
            },
          },
          splitLine: {
            lineStyle: {
              type: 'solid',
              color: labelColor
            }
          },
        }],
        series: [{
          name: "环比",
          type: 'line',
          data: this.data.linkRelativeRatio,
          symbolSize: 1,
          symbol: 'circle',
          smooth: true,
          yAxisIndex: 0,
          showSymbol: false,
          lineStyle: {
            normal: {
              color: colorList[0],
            }
          },
          itemStyle: {
            normal: {
              color: colorList[0],
              borderColor: colorList[0]
            }
          },
        }, {
          name: "同比",
          type: 'line',
          smooth: true,
          symbolSize: 1,
          symbol: 'circle',
          data: this.data.yearOverYear,
          lineStyle: {
            normal: {
              color: colorList[1],
            }
          },
          itemStyle: {
            normal: {
              color: colorList[1],
              borderColor: colorList[1]
            }
          },
        }]
      };
    },
  },
}
</script>

<style scoped>

</style>
